import React from "react";
import { BsDash } from "react-icons/bs";

const Bonus = ({ bonus, awards }) => {
  return (
    <div className="w-full border text-gray-300 bg-darkPink hover:shadow-lg transition-hover duration-200 rounded-lg p-4">
      <h3 className="font-titleFont text-white text-xl md:text-2xl font-semibold">
        Bonus
      </h3>
      <div className="w-full flex justify-start items-center">
        <ul className="mt-1">
          <li className="flex text-base items-center gap-2 hover:text-white">
            <span className="mt-1">
              <BsDash />
            </span>
            {bonus}
          </li>
        </ul>
      </div>
      <hr className="h-[1px] bg-gray-500 mt-2 mb-2" />
      <h3 className="font-titleFont text-white text-xl md:text-2xl font-semibold">
        Award & Certification
      </h3>
      <div className="w-full flex justify-start items-center">
        <ul className="mt-1">
          <li className="flex text-base items-center gap-2 hover:text-white">
            <span className="mt-1">
              <BsDash />
            </span>
            {awards}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Bonus;
